<template>
  <v-list expand nav v-bind="$attrs" v-on="$listeners">
    <template v-for="(item, i) in items">
      <default-list-group v-if="item.items" :key="`group-${i}`" :item="item" />

      <default-list-item v-else-if="checkActivePart(item.part) && ((item.alias !== 'agents' && item.alias !== 'sponsorePayments')) && (item.alias !== 'subAgentTransactions' || hasParentAgent)" :key="`item-${i}`" :item="item" />
    </template>
  </v-list>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    name: 'DefaultList',

    components: {
      DefaultListGroup: () => import('./ListGroup'),
      DefaultListItem: () => import('./ListItem'),
    },

    computed: {
      ...get('auth', [
        'getCurrentUser',
      ]),
      hasParentAgent() {
        var user = this.getCurrentUser
        return !!user?.userData?.agentId
      }
    },

    props: {
      items: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>
